<script>

/**
 * Automodal 
 * 
 * Version 1.7
 * Soporte para args,
 * 
 * Version 1.6
 * Agregado el concepto de archetypeCocinaeasylunchCFG, para administración de dependencias:
 *   Cocinaeasylunch => Cocinaeasylunch_hijo
 * 
 * Version 1.5
 * Remoción de DIV sobrante.
 * 
 * Version 1.4
 * Agrega el concepto haldeItem, que permite manipular los elementos del archetyipo independientemeente 
 * de si son arreglos de objetos o solo objetos.
 * 
 * Version 1.3
 * Remvue el concepto de archetype como prpoiedad por causar conflictos
 * Recomendado switch por item.key en cArchetype para evitar errores de ejecución.
 * 
 * Version 1.2
 * Corrige la actualización desde cArchetype automática de automodal. 
 * (Requiere "UI Edit automodal@1.10")
 * 
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el control de borrado.
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'
import md5 from 'js-md5'
import moment from 'moment'

import { archetype, archetypeCocinaeasylunchCFG, automodalHandler } from './archetype'
import { extractForm } from '@/utils.js'

export default {
    name: 'CocinaeasylunchAutomodal',
    props: {
        conceptId: {
            type: [String, Number],
        },
        args: {
            type: Object,
            default: () => { return {} }
        }
    },
    data: () => {
        return {
            form: extractForm(archetype),
            asides: {
                planes: [],
                // administradores: [],
                // distribuidores: [],
            }
        }
    },
    computed: {
        formArchetypeMD5() {
            return md5(JSON.stringify(this.cArchetype))
        },
        cArchetype() {
            let updated = [];
            _.forEach(archetype(), itemsRow => {
                if (!_.isArray(itemsRow)) {
                    updated.push(this.handleItem(itemsRow));
                    return
                }
                let adding = []
                _.forEach(itemsRow, item => {
                    adding.push(this.handleItem(item))
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        dateDisabledFn(date) {
            const day = new Date(date).getDay();
            return day !== 0; // 0 is Monday
        },
        defineSelectedMonth(fecha_inicio) {
            this.form.mes = moment(fecha_inicio, "YYYY-MM-DD").locale('es').format('MMMM');
        },
        archetypeCocinaeasylunchCFG,
        handleItem(item) {
            // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO
            if (_.isObjectLike(item)) {
                switch (item.key) {
                    case 'plan_id':
                        item.options = _.clone(this.asides.planes)
                        break;
                    case 'tipo':
                    case 'menu_clase':
                    case 'posicion':
                        break;
                    default:
                        // LOCK CHANGES IF ID HAS BEEN DEFINED!
                        // if(this.form.id) item.readonly = true
                        break;
                }
            }
            return item;
        },
        getHandler() {
            return automodalHandler(this.conceptId)
        },
        refresh() {
            this.$emit('refresh');
        },
        checkAsides() {
            const asides = this.$refs.automodal.getAsides();
            if (!!asides) {
                _.forEach(asides, (aside, asideKey) => {
                    this.asides[asideKey] = aside;
                })
                // this.asides.administradores = asides.administradores
                // this.asides.distribuidores = asides.distribuidores
            }
        },
        onDisplay() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
            // console.log('onDisplay', this.$refs.automodal.$refs.fecha_inicio[0].$refs['form-fecha_inicio'].dateDisabledFn = this.dateDisabledFn)
            let RefFechaInicio = this.$refs.automodal.getRefObject('fecha_inicio');
            console.log('onDisplay.RefFechaInicio', RefFechaInicio)
            RefFechaInicio.dateDisabledFn = this.dateDisabledFn
        },
        onHidden() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL SE HA OCULTADO
        },

    },
    watch: {
        'form.fecha_inicio'() {
            if (this.form.fecha_inicio)
                this.defineSelectedMonth(this.form.fecha_inicio)
        },
        'form.id'() {

        }
    }
}
</script>

<template>
    <ui-edit-auto-modal v-model="form" ref="automodal" size="lg" label="Oferta Easylunch" :form-id="form.id"
        :form-archetype="cArchetype" :handler="getHandler()" :allow-aside="false" :allow-delete="true"
        :form-key="formArchetypeMD5" @refresh="refresh()" @defined="checkAsides()" @display="onDisplay"
        @hidden="onHidden">
        <slot name="default"><i class="fa fa-cog"></i></slot>
        <b-col slot="aside" cols="7">
            <!-- LATERAL, REQUIERE :allow-aside="true" -->
            <!-- <grid-input v-model="form.CocinaeasylunchCfg" :archetype="archetypeCocinaeasylunchCFG" /> -->
        </b-col>
        <b-col slot="bottom">
            <!-- AGREGAR AL FONDO... -->
        </b-col>
    </ui-edit-auto-modal>
</template>